import type { CityConfig } from "@/pages/city-template/types";

export const ithacaConfig: CityConfig = {
  city: "Ithaca",
  state: "New York",
  stateAbbr: "NY",
  slug: "ithaca",
  route: "/cities/ithaca",
  title: "Emergency & Expedited Passport Ithaca NY | Same Day Passport Ithaca Cornell",
  metaDescription:
    "Emergency passport Ithaca NY — same day, 24-hour, and 3-5 day expedited passport processing for Tompkins County. Fast Passport Center serves Ithaca, Cornell University, Cortland, and all Finger Lakes communities.",
  h1: "Emergency & Expedited Passport Services in Ithaca, NY",
  heroSubtitle:
    "Ithaca's fast passport solution — from the home of Cornell University to the heart of the Finger Lakes. Whether you're flying out of Ithaca Tompkins International or heading to Syracuse, Fast Passport Center delivers emergency passports in as little as 24 hours and expedited processing in 3-5 days.",
  heroImageUrl:
    "https://readdy.ai/api/search-image?query=Ithaca%20New%20York%20scenic%20view%20of%20Cayuga%20Lake%20from%20Cornell%20University%20campus%2C%20historic%20gothic%20buildings%20and%20clock%20tower%2C%20fall%20foliage%20on%20the%20Finger%20Lakes%20hillside%2C%20warm%20golden%20afternoon%20light%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20beautiful%20college%20town%20and%20lake%20landscape&width=1600&height=700&seq=ny-ithaca-hero-001&orientation=landscape",
  heroImageAlt: "Ithaca New York scenic view of Cayuga Lake from Cornell University campus with fall foliage",
  geoPosition: "42.4430; -76.5019",
  geoPlacename: "Ithaca, New York, United States",
  lastModified: "2026-05-31",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~220 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Ithaca", zips: "14850, 14851, 14852, 14853" },
    { name: "Cortland", zips: "13045, 13046" },
    { name: "Trumansburg", zips: "14886" },
    { name: "Lansing", zips: "14882" },
    { name: "Dryden", zips: "13053" },
    { name: "Groton", zips: "13073" },
    { name: "Auburn", zips: "13021, 13022, 13024" },
    { name: "Elmira", zips: "14901, 14902, 14903, 14904, 14905, 14925" },
    { name: "Corning", zips: "14830, 14831" },
    { name: "Syracuse", zips: "13201-13210, 13211, 13212, 13214, 13215, 13217, 13218, 13219, 13220, 13224, 13225, 13235, 13244, 13250, 13251, 13252, 13261, 13290" },
    { name: "Rochester", zips: "14602, 14603, 14604, 14605, 14606, 14607, 14608, 14609, 14610, 14611, 14612, 14613, 14614, 14615, 14616, 14617, 14618, 14619, 14620, 14621, 14622, 14623, 14624, 14625, 14626, 14627, 14642, 14650, 14652, 14653, 14692" },
    { name: "Binghamton", zips: "13901, 13902, 13903, 13904, 13905, 13933, 13935, 13944, 13945" },
    { name: "Buffalo", zips: "14201-14204, 14206-14210, 14211-14214, 14215, 14216, 14217, 14218, 14219, 14220, 14221, 14222, 14223, 14224, 14225, 14226, 14227, 14228, 14231, 14233, 14240, 14241, 14260, 14261, 14263, 14264, 14265, 14267, 14269, 14270, 14272, 14273, 14276, 14280" },
    { name: "New York City", zips: "10001-10282, 11201-11251" },
  ],
  benefits: [
    {
      icon: "ri-time-line",
      title: "As Fast as 24 Hours",
      desc: "Emergency passport processing for Ithaca travelers with urgent departures — same day service available for documented emergencies.",
    },
    {
      icon: "ri-shield-check-line",
      title: "Registered Courier",
      desc: "U.S. Department of State registered passport courier with direct access to the New York Passport Agency.",
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Real Human Support",
      desc: "Dedicated agents guide you through every step — no chatbots, no automated runaround. Available for Ithaca residents 7 days a week.",
    },
    {
      icon: "ri-map-pin-line",
      title: "Tompkins & Finger Lakes Region",
      desc: "Ithaca, Cornell, Cortland, and the entire Finger Lakes region — we serve all of central New York.",
    },
  ],
  testimonials: [
    {
      name: "Dr. Emily W.",
      location: "Cornell University, Ithaca",
      rating: 5,
      text: "Needed my passport renewed for a conference in Paris. Fast Passport Center processed it in 4 days. They handled everything while I was teaching. Perfect for busy professionals.",
      service: "Expedited Passport",
    },
    {
      name: "Marcus T.",
      location: "Ithaca Commons",
      rating: 5,
      text: "Got a last-minute opportunity to study abroad. Fast Passport Center got my new passport in 5 days. They guided me to the right acceptance facility and reviewed all my docs.",
      service: "New Passport",
    },
    {
      name: "Sarah K.",
      location: "Trumansburg, NY",
      rating: 5,
      text: "Renewed my passport through Fast Passport Center. I chose the 10-day Smart Saver option and it arrived in 7 days. Great service for Finger Lakes residents like me.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "ithaca-1",
      name: "Ithaca Main Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "213 North Meadow Street",
      city: "Ithaca",
      state: "NY",
      zip: "14850",
      phone: "607-273-2828",
      hours: "Mon-Fri 8:30 AM - 5:00 PM, Sat 9:00 AM - 1:00 PM",
      distance: "Downtown Ithaca",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Ithaca passport acceptance facility. First-time applicants and those not eligible for mail-in renewal must apply in person.",
      icon: "ri-building-2-line",
    },
    {
      id: "ithaca-2",
      name: "Cornell University Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "565 Dryden Road",
      city: "Ithaca",
      state: "NY",
      zip: "14850",
      phone: "607-273-1810",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Cornell Campus area",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Cornell University students, faculty, and staff. Passport acceptance services available by appointment.",
      icon: "ri-building-2-line",
    },
    {
      id: "ithaca-3",
      name: "Cortland Post Office",
      type: "Post Office / Passport Acceptance Facility",
      address: "88 Main Street",
      city: "Cortland",
      state: "NY",
      zip: "13045",
      phone: "607-753-2002",
      hours: "Mon-Fri 9:00 AM - 5:00 PM, Sat 9:00 AM - 12:00 PM",
      distance: "Cortland (~25 miles east)",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Passport acceptance services available. Serving Cortland, SUNY Cortland, and east of Ithaca communities.",
      icon: "ri-building-2-line",
    },
  ],
  faqs: [
    {
      q: "How fast can I get an emergency passport in Ithaca?",
      a: "Fast Passport Center offers same-day emergency passport processing in as little as 24 hours for Ithaca residents with documented life-or-death emergencies. For urgent travel within 2 weeks, our 3-5 day expedited service is the most popular option. Standard processing through the post office takes 8-11 weeks.",
    },
    {
      q: "Where is the closest passport acceptance facility in Ithaca?",
      a: "The Ithaca Main Post Office at 213 North Meadow Street is the primary Ithaca passport acceptance facility. The Cornell University Post Office at 565 Dryden Road and Cortland Post Office at 88 Main Street are also convenient options. First-time applicants and those not eligible for mail-in renewal must apply in person.",
    },
    {
      q: "Can I get same-day passport photos in Ithaca?",
      a: "Yes — passport photos are available at CVS Pharmacy, Walgreens, and UPS Store locations throughout Ithaca and Cortland. Cornell University also has a passport photo service. We also offer photo review as part of our service to ensure your 2x2 photos meet all State Department requirements.",
    },
    {
      q: "How much does an expedited passport cost in Ithaca?",
      a: "Government fees are set by the State Department and vary based on passport type (book vs card, large book option). Fast Passport Center's service fees depend on processing speed: 10-day Smart Saver, 3-5 day Expedited, or 24-hour Emergency. Call 877-253-0084 for a personalized quote based on your Ithaca passport needs.",
    },
    {
      q: "Do I need to visit the New York Passport Agency in person?",
      a: "No — if you use Fast Passport Center, you do not need to visit the New York Passport Agency in Manhattan. As a registered courier, we handle the agency submission for you. The only reason to visit the agency directly is for a documented life-or-death emergency, and appointments are extremely difficult to obtain.",
    },
    {
      q: "What is the fastest way to renew a passport in Ithaca?",
      a: "The fastest way to renew a passport in Ithaca is through Fast Passport Center's 3-5 day expedited service. If your most recent passport was issued when you were 16 or older, within the last 15 years, and is undamaged, you may qualify for renewal without an acceptance clerk visit. For even faster renewal, our 24-hour emergency service is available.",
    },
    {
      q: "Can I get a child passport expedited in Ithaca?",
      a: "Yes — Fast Passport Center expedites child passports for minors under 16 in Ithaca and all Tompkins County communities. Both parents must appear with the child or provide notarized consent (Form DS-3053). We review all parental consent documentation before submission to avoid delays.",
    },
    {
      q: "Does Fast Passport Center have an office in Ithaca?",
      a: "Fast Passport Center operates as a remote courier service — we do not have a physical office in Ithaca. We serve the Finger Lakes and all of Tompkins County through our secure overnight shipping and agency submission process. Our headquarters are in Washington, DC.",
    },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Ithaca", address: "various CVS locations across Ithaca and Cortland", hours: "Mon-Sun, hours vary by location" },
    { name: "Walgreens — Ithaca", address: "various Walgreens locations throughout Ithaca area", hours: "Mon-Sun, hours vary by location" },
    { name: "UPS Store — Ithaca", address: "various UPS Store locations in Ithaca and Cortland", hours: "Mon-Fri 9:00 AM - 7:00 PM, Sat 10:00 AM - 4:00 PM" },
    { name: "Cornell University — Campus Service", address: "Cornell University campus, Ithaca, NY", hours: "Mon-Fri 9:00 AM - 5:00 PM" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Ithaca",
      address: "301 3rd Street, Ithaca, NY 14850",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Ithaca DMV office for license renewals and REAL ID applications. Accepts walk-ins but appointments are strongly recommended.",
      featured: true,
    },
    {
      name: "NYS DMV — Cortland",
      address: "112 River Street, Cortland, NY 13045",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Cortland DMV office serving Cortland County and east of Ithaca residents.",
      featured: false,
    },
    {
      name: "NYS DMV — Auburn",
      address: "168 Genesee Street, Auburn, NY 13021",
      hours: "Mon-Fri 8:30 AM - 4:00 PM",
      note: "Auburn DMV office for Cayuga County residents. Alternative for Ithaca area residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ITH",
      name: "Ithaca Tompkins International Airport",
      distance: "In Ithaca, NY",
      address: "1 Culligan Drive, Ithaca, NY 14850",
      note: "Ithaca's regional airport with flights to New York, Philadelphia, and Detroit hubs. Perfect for Finger Lakes and Cornell University travelers.",
      flightUrl: "https://www.ithacaairport.com/",
      flightLabel: "ITH Airport",
      featured: true,
    },
    {
      code: "SYR",
      name: "Syracuse Hancock International Airport",
      distance: "~55 miles from Ithaca",
      address: "1000 Col Eileen Collins Blvd, Syracuse, NY 13212",
      note: "Major upstate New York airport with flights to major U.S. and international hubs. Alternative for Ithaca area travelers with more flight options.",
      flightUrl: "https://www.syrairport.org/",
      flightLabel: "Syracuse Airport",
      featured: false,
    },
    {
      code: "ELM",
      name: "Elmira Corning Regional Airport",
      distance: "~40 miles from Ithaca",
      address: "276 Sing Sing Road, Horseheads, NY 14845",
      note: "Regional airport in the Twin Tiers with flights to Detroit, Orlando, and New York. Alternative for Ithaca area travelers.",
      flightUrl: "https://www.flyelmira.com/",
      flightLabel: "ELM Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-passport-line",
      title: "Emergency Passport",
      description: "For Ithaca travelers with urgent departures within 24 hours to 2 weeks. Direct New York Passport Agency submission with dedicated courier handling.",
      bullets: ["Processing as fast as 24 hours", "Dedicated agent assigned to your case", "Daily status updates"],
      badge: "Fastest",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Fast renewal for Ithaca residents with a valid passport issued within the last 15 years at age 16 or older.",
      bullets: ["3-5 day or 10-day options available", "No acceptance clerk visit required", "Secure overnight document return"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-user-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Ithaca residents with step-by-step guidance through the acceptance clerk process.",
      bullets: ["Complete application review before submission", "Acceptance clerk appointment guidance", "3-5 day or 10-day processing options"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alarm-warning-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement service for Ithaca residents who have lost their passport or had it stolen.",
      bullets: ["DS-64 form guidance included", "Replacement in 3-5 days or 10 days", "Acceptance clerk visit required"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 in Ithaca, with parental consent guidance and acceptance clerk support.",
      bullets: ["Parental consent documentation review", "Both parents present or notarized consent", "3-5 day or 10-day processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal name change for Ithaca residents.",
      bullets: ["Marriage certificate or court order review", "Name change in 3-5 days or 10 days", "No clerk visit for most renewals"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Ithaca travelers with immediate departure needs from Ithaca Tompkins International Airport." },
    { name: "Passport Renewal", description: "Fast passport renewal for Ithaca residents with a recent valid passport." },
    { name: "New Passport", description: "First-time passport application assistance for Ithaca residents." },
    { name: "Lost or Stolen Passport", description: "Passport replacement for Ithaca residents who have lost their passport." },
    { name: "Child Passport", description: "Passport services for minors under 16 in Ithaca and Tompkins County." },
    { name: "Name Change", description: "Passport name change service after marriage, divorce, or legal name change in Ithaca." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Photos must be 2\"x2\" with a plain white or off-white background. Many Ithaca travelers get rejected at the acceptance clerk because their photos don't meet strict State Department specs.",
    },
    {
      icon: "ri-file-list-3-line",
      title: "Missing or Incorrect Forms",
      description: "Using the wrong form (DS-11 vs DS-82) or missing required fields can cause weeks of delays. We review every form before submission.",
    },
    {
      icon: "ri-calendar-line",
      title: "Waiting Too Long to Start",
      description: "Standard processing takes 8-11 weeks. Many Ithaca travelers wait until the last minute, leaving no buffer for problems.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Incorrect Payment Amount",
      description: "Government fees change frequently. Using an outdated check or wrong amount will cause your application to be returned.",
    },
    {
      icon: "ri-shield-line",
      title: "Damaged or Expired ID",
      description: "Your driver's license or state ID must be valid and unexpired. Many applicants don't realize their ID is about to expire until it's too late.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For child passports, both parents must appear or provide notarized consent. Missing documentation is the #1 reason child applications are delayed.",
    },
  ],
  steps: [
    {
      number: "01",
      icon: "ri-file-list-3-line",
      title: "Complete Your Application",
      description: "Fill out your passport application online or over the phone with our Ithaca team. We review everything for accuracy.",
    },
    {
      number: "02",
      icon: "ri-upload-cloud-line",
      title: "Send Us Your Documents",
      description: "Ship your documents via overnight courier to our secure processing center. We confirm receipt and begin review immediately.",
    },
    {
      number: "03",
      icon: "ri-search-line",
      title: "We Review Everything",
      description: "Our agents verify your forms, photos, and supporting documents meet all State Department requirements — no surprises.",
    },
    {
      number: "04",
      icon: "ri-shield-check-line",
      title: "Courier Submission",
      description: "As a registered U.S. Department of State courier, we submit your application directly to the New York Passport Agency.",
    },
    {
      number: "05",
      icon: "ri-passport-line",
      title: "Receive Your Passport",
      description: "Your passport is delivered securely to your Ithaca address. We provide tracking and daily status updates throughout.",
    },
  ],
  processingOptions: [
    {
      speed: "8-11",
      unit: "weeks",
      label: "Standard Processing",
      tag: "Post Office",
      tagColor: "bg-gray-200 text-gray-600",
      features: [
        "Mail-in application",
        "No expedited handling",
        "No dedicated agent",
        "No phone or email contact for your case",
        "Updates only by physical mail letter",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "10",
      unit: "business days",
      label: "Smart Saver",
      tag: "Fast Passport Center",
      tagColor: "bg-green-100 text-green-700",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned",
        "Daily status updates",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "3-5",
      unit: "business days",
      label: "Expedited Processing",
      tag: "Recommended",
      tagColor: "bg-[#1A365D] text-white",
      features: [
        "Secure overnight shipping included",
        "Document review before submission",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "24",
      unit: "hours",
      label: "Emergency Processing",
      tag: "Life or Death",
      tagColor: "bg-red-100 text-red-600",
      features: [
        "For documented life-or-death emergencies only",
        "Requires proof of emergency travel",
        "Strictly for documented life-or-death emergencies",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Must book weeks in advance", fpc: "No appointment needed — we handle agency access" },
    { feature: "Processing Speed", agency: "1-2 business days (if you get an appointment)", fpc: "As fast as 3-5 days or 24 hours for emergencies" },
    { feature: "Document Review", agency: "No pre-check — one mistake means restart", fpc: "Complete review before submission — we catch errors" },
    { feature: "Travel Proof", agency: "Requires printed itinerary with confirmed travel within 2 weeks", fpc: "Flexible documentation requirements" },
    { feature: "Updates", agency: "No phone or email support — only mail updates", fpc: "Daily status updates via phone and email" },
    { feature: "Guarantee", agency: "No guarantee of appointment or same-day processing", fpc: "Reserved agency slots with predictable processing" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "New York City", route: "/cities/new-york-city" },
    { name: "Brooklyn", route: "/cities/brooklyn" },
    { name: "Queens", route: "/cities/queens" },
    { name: "Buffalo", route: "/cities/buffalo" },
    { name: "Albany", route: "/cities/albany-ny" },
    { name: "Syracuse", route: "/cities/syracuse" },
    { name: "Rochester", route: "/cities/rochester" },
    { name: "Yonkers", route: "/cities/yonkers" },
    { name: "The Bronx", route: "/cities/the-bronx" },
    { name: "Staten Island", route: "/cities/staten-island" },
    { name: "Long Island", route: "/cities/long-island" },
    { name: "Binghamton", route: "/cities/binghamton" },
    { name: "Elmira", route: "/cities/elmira" },
    { name: "Corning", route: "/cities/corning" },
    { name: "Jamestown", route: "/cities/jamestown" },
    { name: "New York State", route: "/states/new-york" },
  ],
  fpcOfficeNote:
    "Fast Passport Center serves Ithaca and all of the Finger Lakes as a remote courier service. We do not have a physical office in Ithaca, but our secure overnight shipping network ensures your documents reach our processing center quickly and safely.",
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeDistance: "Remote courier service — Ithaca area",
  serviceAreaIntro:
    "Fast Passport Center provides expedited passport services to Ithaca and all of Tompkins County. From the Cornell University campus to the shores of Cayuga Lake, from Cortland to Trumansburg — we serve the Finger Lakes with the same fast, reliable processing.",
  nearbyCitiesIntro:
    "We proudly serve Ithaca and all surrounding communities across Tompkins County and the Finger Lakes region. Whether you're in Cortland, Trumansburg, or Lansing, our expedited passport services are available to you.",
  howItWorksIntro:
    "Our Ithaca customers follow a simple, proven process to get their passports fast. No agency visits, no waiting in lines, no guessing.",
  mistakesIntro:
    "These are the most common mistakes Ithaca travelers make when applying for an expedited passport. Avoiding them saves weeks of delays.",
  testimonialsIntro:
    "Ithaca and Finger Lakes travelers trust Fast Passport Center for their urgent passport needs. Here's what they say about our service.",
  faqIntro:
    "Common questions about emergency and expedited passport services in Ithaca. If you don't see your question here, call us at 877-253-0084.",
  statePageRoute: "/states/new-york",
  statePageName: "New York Passport Services",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
};

export default ithacaConfig;